var _path, _path2, _path3, _ellipse, _ellipse2, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIlNomessages = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 260,
    fill: "none",
    viewBox: "0 0 330 260",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H330V260H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H330V260H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H330V260H0z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.985,
    cy: 115.543,
    fill: "#FAD2BC",
    rx: 4.985,
    ry: 4.979
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.48,
    cy: 232.684,
    fill: "#FAD2BC",
    rx: 4.675,
    ry: 4.666
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07735",
    strokeWidth: 3,
    d: "M53.606 203.536c0 3.883-3.155 7.036-7.053 7.036s-7.053-3.153-7.053-7.036c0-3.883 3.155-7.036 7.053-7.036s7.053 3.153 7.053 7.036z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#EE5F10",
    rx: 1.246,
    transform: "rotate(-44.944 77.852 -55.564)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#EE5F10",
    rx: 1.246,
    transform: "rotate(-44.944 95.538 -62.92)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#EE5F10",
    rx: 1.246,
    transform: "rotate(44.978 -6.08 111.757)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.491,
    height: 6.851,
    fill: "#EE5F10",
    rx: 1.246,
    transform: "rotate(44.944 -23.804 104.478)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.567,
    height: 6.596,
    x: 318.823,
    y: 116.606,
    fill: "#EE5F10",
    rx: 1.283
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.567,
    height: 6.596,
    x: 318.823,
    y: 127.934,
    fill: "#EE5F10",
    rx: 1.283
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.399,
    height: 7.059,
    x: 330,
    y: 124.588,
    fill: "#EE5F10",
    rx: 1.199,
    transform: "rotate(90 330 124.588)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.399,
    height: 7.059,
    x: 317.119,
    y: 124.588,
    fill: "#EE5F10",
    rx: 1.199,
    transform: "rotate(90 317.119 124.588)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F6",
    stroke: "#F28C54",
    strokeWidth: 2,
    d: "M236.141 154.24l-15.938-13.282-.278-.231H149.25c-4.302 0-7.789-3.488-7.789-7.789V80.789c0-4.302 3.487-7.789 7.789-7.789h79.102c4.301 0 7.789 3.487 7.789 7.79v73.45z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F6",
    stroke: "#F28C54",
    strokeWidth: 2,
    d: "M110.578 188.188h-.362l-.278.231L94 201.701v-62.318c0-4.302 3.487-7.789 7.789-7.789h79.102c4.302 0 7.789 3.487 7.789 7.789v41.015c0 4.302-3.487 7.79-7.789 7.79h-70.313z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF89",
    d: "M155.109 118.875h30.762c1.618 0 2.93-1.312 2.93-2.93s-1.312-2.929-2.93-2.929h-30.762c-1.618 0-2.929 1.311-2.929 2.929 0 1.618 1.311 2.93 2.929 2.93z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    d: "M223.021 93.804l-12.889 16.961-6.511-8.218c-1.05-1.325-3.117-1.648-4.618-.721-1.5.928-1.865 2.755-.815 4.081l9.285 11.718c.621.784 1.635 1.25 2.716 1.25h.033c1.093-.009 2.111-.495 2.72-1.296l15.584-20.508c1.021-1.343.616-3.164-.904-4.066-1.52-.901-3.581-.544-4.601.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF89",
    d: "M155.109 104.227h17.579c1.614 0 2.929-1.316 2.929-2.93s-1.315-2.93-2.929-2.93h-17.579c-1.614 0-2.929 1.316-2.929 2.93s1.315 2.93 2.929 2.93zM185.871 104.227c1.618 0 2.93-1.312 2.93-2.93s-1.312-2.93-2.93-2.93-2.93 1.312-2.93 2.93 1.312 2.93 2.93 2.93zM110.93 162.82h17.578c1.614 0 2.93-1.315 2.93-2.929 0-1.615-1.316-2.93-2.93-2.93H110.93c-1.615 0-2.93 1.315-2.93 2.93 0 1.614 1.315 2.929 2.93 2.929zM128.508 172H110.93c-1.615 0-2.93 1.315-2.93 2.93 0 1.614 1.315 2.929 2.93 2.929h17.578c1.614 0 2.93-1.315 2.93-2.929 0-1.615-1.316-2.93-2.93-2.93zM141.34 162.82c1.618 0 2.93-1.311 2.93-2.929 0-1.618-1.312-2.93-2.93-2.93s-2.93 1.312-2.93 2.93 1.312 2.929 2.93 2.929zM110.93 148.172h46.875c1.618 0 2.929-1.312 2.929-2.93s-1.311-2.93-2.929-2.93H110.93c-1.618 0-2.93 1.312-2.93 2.93s1.312 2.93 2.93 2.93z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FED9B4",
    strokeWidth: 3,
    d: "M256.223 23.347c0 3.227-2.621 5.848-5.861 5.848-3.24 0-5.862-2.621-5.862-5.848 0-3.226 2.622-5.847 5.862-5.847s5.861 2.62 5.861 5.847z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIlNomessages, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/il_no messages.6ba4e78d.svg";
export { ForwardRef as ReactComponent };